// extracted by mini-css-extract-plugin
module.exports = {"container":"balanceCard_container__kBzAB","card-totalBal":"balanceCard_card-totalBal__3TBVX","card-outline":"balanceCard_card-outline__3rHGF"};